module.exports = __webpack_public_path__ + "img/badge_first_simple.04147867.png";